import { Center, type CenterProps } from '@/ui';

export const CenteredView = (props: CenterProps) => {
  return (
    <Center
      color="customgray.mid"
      flexDir="column"
      fontSize="lg"
      m="auto"
      textAlign="center"
      w="65%"
      {...props}
    />
  );
};
